module.exports = __webpack_public_path__ + "img/boy-front-clay.25a1f1fb.png";